import {useState} from "react";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_ADD_APARTMENT, API_APARTMENT, API_WAITING_LIST} from "../common/api/apiConstants";

export const useWaitingListApartments = () => {
    const [loadingDeleteApartment, setLoadingDeleteApartment] = useState(false);
    const [errorDeleteApartment, setErrorDeleteApartment] = useState(null);

    const [loadingAddApartment, setLoadingAddApartment] = useState(false);
    const [errorAddApartment, setErrorAddApartment] = useState(null);

    const deleteApartment = (entryId, apartmentShortCode) => {
        setLoadingDeleteApartment(true);
        setErrorDeleteApartment(null);

        return bookingAPI.delete(API_WAITING_LIST + "/" + entryId + API_APARTMENT + apartmentShortCode)
            .then(res => {
                setLoadingDeleteApartment(false);
                return res;
            })
            .catch((err) => {
                setLoadingDeleteApartment(false);
                setErrorDeleteApartment(err.response);
                return (err.response);
            });
    };

    const addApartment = (entryId, apartmentShortCode) => {
        setLoadingAddApartment(true);
        setErrorAddApartment(null);

        return bookingAPI.post(API_WAITING_LIST + "/" + entryId + API_ADD_APARTMENT, {apartment_category: apartmentShortCode})
            .then(res => {
                setLoadingAddApartment(false);
                return res;
            })
            .catch((err) => {
                setLoadingAddApartment(false);
                setErrorAddApartment(err.response);
                return (err.response);
            });
    };

    return {
        deleteApartment,
        loadingDeleteApartment,
        errorDeleteApartment,
        setErrorDeleteApartment,
        addApartment,
        loadingAddApartment,
        errorAddApartment,
        setErrorAddApartment
    };
};

